import { MockMethod } from 'vite-plugin-mock';
import { Random } from 'mockjs';
import { resultSuccess } from '../_util';
import { getBasicData } from '/@/views/customer/manage/tableData';

function getRandomPics(count = 10): string[] {
  const arr: string[] = [];
  for (let i = 0; i < count; i++) {
    arr.push(Random.image('800x600', Random.color(), Random.color(), Random.title()));
  }
  return arr;
}
function getBasicData(){
  const arr: string[] = ["养老","失业","工伤","生育","医疗","补充（大病）医疗保险","残保金","补充养老保险","重疾险","公积金"];
  return  arr
}

const demoList = (() => {
  const result = {
    id: 0,
    beginTime: '@datetime',
    endTime: '@datetime',
    address: '@city()',
    name: '@cname()',
    phonenumber: /^1[0-9]{10}$/,
    email: '@email()',
    name3: '@cname()',
    name4: '@cname()',
    name5: '@cname()',
    name6: '@cname()',
    name7: '@cname()',
    name8: '@cname()',
    remark: '@csentence()',
    'orgName|1':['设计部门', '技术部门', '销售部门'],
    'workStatus|1':['待入职', '入职过程中', '在职','离职','离职过程中','已离职','取消入职',],
    censusCity:'@city()',
    idcard_no: '41273904943434993324',
    service_status: Math.ceil(Math.random() * (3 - 1) + 1),
    service_type: Math.ceil(Math.random() * (3 - 1) + 1),
    idcard_type: Math.ceil(Math.random() * (3 - 1) + 1),
    'idcardtype|1':['居民身份证', '军官证', '外籍人暂住证'],
    'census|1':['农村户口', '城镇户口'],
    idcardno:'632323190605266929',
    'wages':Random.float( 3000, 300000,2,2 ),
    basedPoints:'13800000000',
    canbaoplan:'@ctitle(5, 8)',
    sbcity:'@city()',
    gjjcity:'@city()',
    sbfeedback:'@ctitle(10, 20)',
    gjjfeedback:'@ctitle(10,20 )',
    'sbstatus|1':['待参保', '处理中', '已参保','已停保'],
    'gjjstatus|1':['待参保', '处理中', '已参保','已停保'],
    'types|1':['补缴', '补差'],
    'sbpaymentstatus|1':['待办理', '办理中','办理成功','办理失败'],
    'gjjpaymentstatus|1':['待办理', '办理中','办理成功','办理失败'],
    sbpaymentDate:'@date("yyyy-MM-dd")',
    gjjpaymentDate: '@date("yyyy-MM-dd")',
    reportname:'@ctitle(5, 8)',
    describe:'@ctitle(20, 30)',
    avatar: Random.image('400x400', Random.color(), Random.color(), Random.first()),
    imgArr: getRandomPics(Math.ceil(Math.random() * 3) + 1),
    imgs: getRandomPics(Math.ceil(Math.random() * 3) + 1),
    date: `@date('yyyy-MM-dd')`,
    time: `@time('HH:mm')`,
    createTime: `@date('yyyy-MM-dd')`,
    applyTime: `@time('HH:mm')`,
    'no|100000-10000000': 100000,
    'status|1': ['normal', 'enable', 'disable'],
    'sbtable|1':["养老","失业","工伤","生育","医疗","补充（大病）医疗保险","残保金","补充养老保险","重疾险","公积金"]
  }
  return result;
})();

export default [
  {
    url: '/basic-api/table/getDetails',
    timeout: 100,
    method: 'get',
    response: ({  }) => {
      return resultSuccess(demoList);
    },
  },
] as MockMethod[];
